module.exports = __webpack_public_path__ + "images/emoji/metal.d4833ff41d4ee13efce5.png";